import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, Input, OnChanges } from '@angular/core';
import MetisMenu from 'metismenujs';
import { EventService } from '../../core/services/event.service';
import { Router, NavigationEnd } from '@angular/router';
import { UsersRoleService } from '../user-role/users-role.service';
import { HttpClient } from '@angular/common/http';
import { MENU } from './menu';
import { MenuItem } from './menu.model';
import { AuthenticationService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})

/**
 * Sidebar component
 */
export class SidebarComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('componentRef') scrollRef;
  @Input() isCondensed = false;
  menu: any;
  loginUser: any;
  data: any;
  user:any;
  loginUsers: any;
  userMenu:any;
  customConsumer:any
  menuItems = [];
  @ViewChild('sideMenu') sideMenu: ElementRef;
  activeMenuId: number | null = null;
  intro: any;
  constructor(private eventService: EventService, private _userRole:UsersRoleService,
     private router: Router,
     private authService:AuthenticationService, private http: HttpClient) {
     router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        // console.log('jkkkk');
        
        this._activateMenuDropdown();
        this._scrollElement();
      }
    });

    this.authService.subjectName.subscribe((res:any)=>{
      this.showRole();
      this.initialize();
      this._scrollElement();
    })
  }

  ngOnInit() {
    this.showRole();
    this.initialize();
    this._scrollElement();
  }

  

  showRole(){
    let userRolLogin =JSON.stringify(sessionStorage.getItem('userRole'));
    this.user=JSON.parse(userRolLogin);
    this.loginUser = JSON.parse(sessionStorage.getItem('Useremail'));
    let customConsumers =JSON.stringify(sessionStorage.getItem('custom-consumer'));
    this.customConsumer=JSON.parse(customConsumers); 
  }

  ngAfterViewInit() {
    this.menu = new MetisMenu(this.sideMenu.nativeElement);
    this._activateMenuDropdown();
  }

  // toggleMenu(event) {
  //   event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  // }

  ngOnChanges() {
    if (!this.isCondensed && this.sideMenu || this.isCondensed) {
      setTimeout(() => {
        this.menu = new MetisMenu(this.sideMenu.nativeElement);
      });
    } else if (this.menu) {
      this.menu.dispose();
    }
  }
  _scrollElement() {
    setTimeout(() => {
      if (document.getElementsByClassName("mm-active").length > 0) {
        const currentPosition = document.getElementsByClassName("mm-active")[0]['offsetTop'];
        if (currentPosition > 500)
        if(this.scrollRef.SimpleBar !== null)
          this.scrollRef.SimpleBar.getScrollElement().scrollTop =
            currentPosition + 300;
      }
    }, 300);
  }

  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  _activateMenuDropdown() {
    this._removeAllClass('mm-active');
    this._removeAllClass('mm-show');
    const links = document.getElementsByClassName('side-nav-link-ref');
    let menuItemEl = null;
    const paths = [];
    for (let i = 0; i < links.length; i++) {
      paths.push(links[i]['pathname']);
    }
    var itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf('/');
      const item = window.location.pathname.substr(0, strIndex).toString();
      menuItemEl = links[paths.indexOf(item)];
    } else {
      menuItemEl = links[itemIndex];
    }
    if (menuItemEl) {
      menuItemEl.classList.add('active');
      const parentEl = menuItemEl.parentElement;
      if (parentEl) {
        parentEl.classList.add('mm-active');
        const parent2El = parentEl.parentElement.closest('ul');
        if (parent2El && parent2El.id !== 'side-menu') {
          parent2El.classList.add('mm-show');
          const parent3El = parent2El.parentElement;
          if (parent3El && parent3El.id !== 'side-menu') {
            parent3El.classList.add('mm-active');
            const childAnchor = parent3El.querySelector('.has-arrow');
            const childDropdown = parent3El.querySelector('.has-dropdown');
            if (childAnchor) { childAnchor.classList.add('mm-active'); }
            if (childDropdown) { childDropdown.classList.add('mm-active'); }
            const parent4El = parent3El.parentElement;
            if (parent4El && parent4El.id !== 'side-menu') {
              parent4El.classList.add('mm-show');
              const parent5El = parent4El.parentElement;
              if (parent5El && parent5El.id !== 'side-menu') {
                parent5El.classList.add('mm-active');
                const childanchor = parent5El.querySelector('.is-parent');
                if (childanchor && parent5El.id !== 'side-menu') { childanchor.classList.add('mm-active'); }
              }
            }
          }
        }
      }
    }

  }

  get isGpsInsight(): boolean {
    const raw = sessionStorage.getItem('custom-consumer') || this.customConsumer || '';
    return typeof raw === 'string' && raw.replace(/['"]+/g, '').trim().toLowerCase() === 'gpsinsight';
  }

  initialize(): void {
    const isGpsInsight = this.isGpsInsight;
    this.menuItems = MENU.map(item => {
      if (item.subItems && item.subItems.length > 0) {
        return {
          ...item,
          subItems: item.subItems.filter(sub => {
            if (sub.label === 'Threshold Profile' || sub.link === 'managefleets/threshold-profile') {
              return isGpsInsight;
            }
            return true;
          })
        };
      }
      return { ...item };
    });
  }

  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  toggleMenu(menuId: number) {
    this.activeMenuId = this.activeMenuId === menuId ? null : menuId;
  }

  isMenuActive(menuId: number): boolean {
    return this.activeMenuId === menuId;
  }

  
}
